import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  ListItem,
  MainListItems,
  SecondaryListItems,
} from "../Dashboard/ListItems";
import logo from "../../Assets/logo.png";
import textLogo from "../../Assets/textLogo.png";
import ArticlesList from "./ArticlesList";
import { useSearchParams } from "react-router-dom";
import { useConcerns } from "../ConcernData/ConcernDataList";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Articles() {
  const [open, setOpen] = React.useState(true);
  const [concerns, fetchConcerns] = useConcerns();
  const [searchParams, setSearchParams] = useSearchParams();

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          style={{ backgroundColor: "#F2A040", boxShadow: "none" }}
          position="absolute"
          open={open}
        >
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: "36px",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="#fffff"
              noWrap
              sx={{ flexGrow: 1, fontWeight: "bold" }}
            >
              Articles
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: [1],
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                style={{ marginRight: "20px" }}
                height="34px"
                width="48px"
                src={logo}
                alt=""
              />
              <img
                style={{ marginRight: "5px" }}
                height="18px"
                width="110px"
                src={textLogo}
                alt=""
              />
            </Box>
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List component="nav">
            {<MainListItems />}
            <Divider sx={{ my: 1 }} />
            <Typography variant="caption" ml="22%" color="#F2A040">
              Filter By Concern
            </Typography>
            {concerns.map((concern) => (
              <ListItem
                key={concern.id}
                IconComponent={() => {}}
                primary={concern.isEnglishTitle}
                onClick={() => {
                  setSearchParams({ concern: concern.id });
                }}
              ></ListItem>
            ))}
            <Divider sx={{ my: 1 }} />
            {<SecondaryListItems />}
          </List>
        </Drawer>
        <Box sx={{ width: "80%", margin: "120px 40px" }}>
          <ArticlesList />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
